export const setStorage = (key, value) => {
  const valueAsString = JSON.stringify(value);

  localStorage.setItem(key, valueAsString);
};

export const getStorage = key => {
  const valueAsString = localStorage.getItem(key);

  return JSON.parse(valueAsString);
};

export const removeStorageItem = key => {
  localStorage.removeItem(key);
};

export const storageKeys = {
  QUESTIONS_GET_ALL_RESULT: 'questionsGetAll.result',
  QUESTIONS_GET_CATEGORIES_RESULT: 'questionsGetCategories.result',
  SELECTED_ANSWERS: 'selectedAnswers',
};



// WEBPACK FOOTER //
// ./src/utils/localStorage.js